export const TICKETS_TOOLBAR_TITLE = 'Tickets';
export const CREATE_TICKET_TITLE = 'Create a new ticket';
export const BACK_TO_MENU = 'Back to Menu';

export const TICKETS_TABLE_HEAD_CELLS = [
    { id: 'dueDate', numeric: false, disablePadding: false, label: 'Due Date' },
    { id: 'customerName', numeric: false, disablePadding: false, label: 'Customer Name' },
    { id: 'originalTrackingId', numeric: false, disablePadding: false, label: 'Tracking Number' },
    { id: 'orderId', numeric: false, disablePadding: false, label: 'Order ID' },
    { id: 'ticketIssueName', numeric: false, disablePadding: false, label: 'Issue' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'createdByName', numeric: false, disablePadding: false, label: 'Created By' },
    { id: 'assignedToName', numeric: false, disablePadding: false, label: 'Assigned To' }
];

export const DEFAULT_SORT_BY_HEAD_CELL = 'dueDate';
export const ROWS_PER_PAGE = 50;

export const ISSUES = [
    'Damaged Item Received',
    'Wrong Item Sent',
    'Lost Package',
    'Wrong Item Ordered'
];
export const ACTIONS = {
    'Wrong Item Sent': [
        'Send Redirect Label',
        'Send Return Label',
        'Issue Refund',
        'Send Replacement Package',
        'Case Closed'
    ],
    'Wrong Item Ordered': [
        'Redirect',
        'Issue Refund',
        'Case Closed'
    ],
    'Damaged Item Received': [
        'Send Replacement',
        'Case Closed'
    ],
    'Lost Package': [
        'Tough'
    ]

};

export const SAVE = 'Save';
export const CANCEL = 'Cancel';

export const ADD_ACTION = 'Add an Action';

export const TASKS_CHECKBOXES_HEADER = 'Tasks';

export const ADD_ACTION_BUTTON_TEXT = "Add Action";

export const COMPLETED_STATUS = 'Completed';

export const REFUND_DETAIL_MAP = {
    'salePrice' : 'Sale Price',
    'missingFilterAmount' : 'Missing/Damage Filter',
    'originalShippingCost' : 'Restocking Fees',
    'returnShippingCost' : 'Return Label Fee',
    'redirectDifference' : 'Difference of Labels',
    'otherCost' : 'Other Charges'
}
export const REFUND_DETAIL_TAX_MAP = {
    'saleTax' : 'Sales Tax',
    'missingFilterTax' : 'Missing/Damage Filter Tax',
    'originalShippingCostTax' : 'Restocking Fees Tax',
    'returnShippingCostTax': 'Return Label Fee Tax',
    'redirectDifferenceTax': 'Difference of Labels Tax',
    'otherCostCostTax' : 'Other Charges Tax'
}
export const DEFAULT_ROWS_PER_PAGE = 10;
export const ROWS_PER_PAGE_LABEL = 'Tickets per page';

export const SHOW_MY_TICKETS = "Show my tickets only";
export const SHOW_COMPLETED_TICKETS = "Show completed tickets";

export const WRONG_ITEM_ORDERED_SHORTCODE_LABEL = "Product Ordered (Shortcode)";
export const WRONG_ITEM_ORDERED_QUANTITY_LABEL = "Quantity Ordered";

export const WRONG_ITEM_SENT_SHORTCODE_LABEL = "Product Sent (Shortcode)";
export const WRONG_ITEM_SENT_QUANTITY_LABEL = "Quantity Sent";

export const ACTION_LABEL = "Select an action"


export const TICKET_SETTINGS_TOOLBAR_TITLE = "Ticket Settings";


export const RETURN_LABEL_COST_INFO = "Return label cost if one was provided to the customer"
export const PRICE_INFO = "Purchase price of the product. Tax is automatically taken into account"
export const SHIPPING_COST_INFO = "Original shipping cost incurred"
export const OTHER_COSTS_INFO_PART1 = "Additional cost as a percentage or fix dollar amount"
export const DIFFERENCE_REDIRECT_LABEL_INFO = "The difference between the shipping cost that we would incur if we ship the product directly to the new customer and the shipping cost from the original customer to the new customer. If this difference is less than or equal to 0, no amount will be deducted from or credited to the original customer"
export const REFUND_TYPES = {
    FULL_REFUND: 'Full Refund',
    DEDUCT_RESTOCKING_FEE_ONLY: 'Deduct Restocking Fee Only',
    DEDUCT_RESTOCKING_FEE_AND_RETURN_COST: 'Deduct Restocking Fee And Return Cost',
    REDIRECT_REFUND: 'Redirect Refund'
}